<template>
  <div class="content">
    <el-tabs class="tabLv3 relaAlarm" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警下载
        </span>
        <div class="normalNav zaddBtn">
          <button class="BtnSmPurple" @click="download">导出</button>
        </div>
        <div class="searchForm1 alarmSearchForm">
          <el-form>
            <el-form-item label="日期">
              <el-date-picker placeholder="请选择日期" v-model="form.date" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <h3>下载说明</h3>
          <ul>
            <li>(1).下载数据为excel格式，信息为告警日期-告警信息-序列号</li>
            <li>(2).下载的告警数据是按天生成</li>
            <li>
              (3).选择日期后点击导出按钮，下载告警数据，如果不选择日期则不能下载
            </li>
          </ul>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabName: 'jsgl',
      form: {
        date: '',
      },
    }
  },
  components: {
    downloadBtn: () => import('public/download'),
  },
  methods: {
    download() {
      if (this.form.date == '') {
        this.$message.warning('请先选择日期')
        return
      }
      this.$axiosget('operation/alExcel/info', {
        params: {
          startTime: this.form.date,
          endTime: this.form.date,
        },
      }).then((res) => {
        const a = document.createElement('a')
        const u = process.env.API_HOST + res.data.data.list[0].url
        a.href = u
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
    },
  },
}
</script>

<style lang='less' scoped>
.tabLv3 {
  /deep/ .el-tabs__content {
    .el-tab-pane {
      .tableWrapper {
        h3,
        ul {
          color: #ffffff;
          text-indent: 80px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/alarm/downloadAlarm/index.vue